import { Hidden } from "@mui/material";

import React, { Fragment, useState, useEffect } from "react";
import { Grid, Typography, Paper } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import InboxIcon from "@mui/icons-material/Inbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import { Link } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import clsx from "clsx";
import { useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MailIcon from "@mui/icons-material/Mail";
import { useSelector, useDispatch } from "react-redux";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreIcon from "@mui/icons-material/MoreVert";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import RestoreIcon from "@mui/icons-material/Restore";
import { loadUser, login } from "../actions/auth";
import ClassIcon from "@mui/icons-material/Class";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import SettingsIcon from "@mui/icons-material/Settings";
import SchoolIcon from "@mui/icons-material/School";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import Snackbar from "@mui/material/Snackbar";
import Card from "@mui/material/Card";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { logout } from "../actions/auth";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import ListItemButton from "@mui/material/ListItemButton";
import MenuIcon from "@mui/icons-material/Menu";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import ThumbsUpDownIcon from "@mui/icons-material/ThumbsUpDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import Button from "@mui/material/Button";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteIcon from "@mui/icons-material/Delete";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Tooltip from "@mui/material/Tooltip";
import Slide from "@mui/material/Slide";
import { getNotifications } from "../actions/auth";
import { API_URL } from "../actions/auth";
import { themeStyle, themeStyleDark } from "./Components";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import MovieIcon from "@mui/icons-material/Movie";
import AssessmentIcon from '@mui/icons-material/Assessment';
import MessageIcon from '@mui/icons-material/Message';

const drawerWidth = 310;

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function Sidebar(props) {
  const [showSnack, setShowSnack] = useState(false);
  const [snack, setSnack] = useState("");
  const [showSnack2, setShowSnack2] = useState(false);
  const [snack2, setSnack2] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);

  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [randomText, setRandom] = useState(makeid(4));

  const [notificationList, setNotificationList] = useState([]);

  const handleDrawerOpen = () => {
    setOpen(true);
    dispatch({ type: "SIDEBAR_SWITCH", payload: true });
  };
  const handleDrawerClose = () => {
    setOpen(false);
    dispatch({ type: "SIDEBAR_SWITCH", payload: false });
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isNotificationsOpen = Boolean(anchorE2);

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const [audio, setAudio] = useState(
    new Audio(require("../sounds/notification.mp3"))
  );
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleNotificationsMenuOpen = (event) => {
    setAnchorE2(event.currentTarget);
  };

  const handleNotificationsClose = () => {
    setAnchorE2(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    backgroundColor:
      state.auth.theme == "dark"
        ? themeStyleDark.backgroundColor
        : themeStyle.backgroundColor,
    color:
      state.auth.theme == "dark"
        ? themeStyleDark.primaryColor
        : themeStyle.primaryColor,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      // marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
  });

  const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(9)} + 1px)`,
    },
  });

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    "& a": {
      color: "gray",
      textDecoration: "none",

      "&:hover": {
        textDecoration: "none",
      },
    },
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }));

  const config = {
    headers: {
      Authorization: state.auth.token,

      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    dispatch(getNotifications());
    audio.load();
  }, []);

  function playAudio() {
    const audioPromise = audio.play();
    if (audioPromise !== undefined) {
      audioPromise
        .then((_) => {
          // autoplay started
        })
        .catch((err) => {
          // catch dom exception
          console.info(err);
        });
    }
  }

  function updateNotificationSeen(notification_id) {
    var body = {
      email: state.auth.user.email,
      notification_id: notification_id,
    };
    body = JSON.stringify(body);
    axios
      .post(API_URL + "update_notification_seen", body, config)
      .then((res) => {
        getNotifications();
      });
  }

  function clearAllNotifications() {
    setNotificationList([]);
    setRandom(makeid(3));

    var body = {
      email: state.auth.user.email,
      notifications: notificationList,
    };
    body = JSON.stringify(body);
    axios
      .post(API_URL + "clear_all_notifications", body, config)
      .then((res) => {});
  }

  var name;
  switch (window.location.pathname) {
    case "/":
      name = "Dashboard";
      break;
    case "/dashboard":
      name = "Dashboard";
      break;
    case "/ranking":
      name = "Holistic Ranking";
      break;
    case "/messenger":
      name = "Messenger";
      break;
    case "/students":
      name = "Students";
      break;
    case "/teachers":
      name = "Teachers";
      break;
    case "/settings":
      name = "Settings";
      break;
    case "/support":
      name = "Support";
      break;
    case "/feedback":
      name = "Feedback";
      break;
    case "/results":
      name = "Results";
      break;
    case "/events":
      name = "Events";
      break;
    case "/attendance":
      name = "Attendance";
      break;
    case "/exams":
      name = "Examinations";
      break;
    case "/approvals":
      name = "Approvals";
      break;
    case "/notifications":
      name = "Notifications";
      break;
    default:
      name = "Dashboard";
  }

  const menuId = "primary-search-account-menu";
  const notificationsMenuId = "primary-notifications-menu";

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <Link
        style={{
          textDecoration: "none",
          color:
            state.auth.theme == "dark"
              ? themeStyleDark.textColor
              : themeStyle.textColor,
        }}
        to={"/settings"}
      >
        <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      </Link>
      <Link
        style={{
          textDecoration: "none",
          color:
            state.auth.theme == "dark"
              ? themeStyleDark.textColor
              : themeStyle.textColor,
        }}
        to={"/support"}
      >
        <MenuItem onClick={handleMenuClose}>Support</MenuItem>
      </Link>
      <Link
        style={{
          textDecoration: "none",
          color:
            state.auth.theme == "dark"
              ? themeStyleDark.textColor
              : themeStyle.textColor,
        }}
        to={"/logout"}
      >
        <MenuItem onClick={handleMenuClose}>Logout</MenuItem>
      </Link>
    </Menu>
  );

  const renderNotifications = (
    <Menu
      anchorEl={anchorE2}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={notificationsMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isNotificationsOpen}
      onClose={handleNotificationsClose}
    >
      {notificationList.map((notification, index) => (
        <MenuItem
          style={{
            width: "500px",
            height: "60px",
            display: "flex",
            justifyContent: "space-between",
          }}
          onClick={() => {
            updateNotificationSeen(notification["id"]);
            handleNotificationsClose();

            navigate(
              "/" + notification["page"] + "?tab=" + notification["tab"]
            );
          }}
          sx={{
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: "#d7ecff",
            },
          }}
        >
          <span>
            <span
              style={{
                marginTop: "-20px",
                fontWeight: "bold",
                fontFamily: "Lato-Regular",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            >
              {notification["title"]}
            </span>
            <div
              style={{
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.textColor
                    : themeStyle.textColor,
                marginTop: "-5px",
              }}
            >
              {notification["body"]}
            </div>
          </span>
        </MenuItem>
      ))}
      {notificationList.length == 0 ? (
        <MenuItem
          style={{
            width: "500px",
            height: "30px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>
            <span style={{ color: "grey", textAlign: "left" }}>
              No new notifications.
            </span>
          </span>
          <EmojiEmotionsIcon style={{ color: "#FFD960" }} />
        </MenuItem>
      ) : (
        ""
      )}
      <br />
      <Link
        style={{ textDecoration: "none", color: "#FFA500" }}
        to="/notifications"
      >
        <MenuItem
          style={{
            width: "500px",
            height: "40px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div style={{ display: "flex" }}>
            <span
              style={{
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                textAlign: "right",
              }}
            >
              See all notifications
            </span>
            <ArrowForwardIosIcon
              style={{
                marginTop: "-3px",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                marginLeft: "15px",
              }}
            />
          </div>
        </MenuItem>
      </Link>

      <MenuItem
        onClick={() => clearAllNotifications()}
        style={{
          width: "500px",
          height: "40px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <div style={{ display: "flex" }}>
          <span style={{ color: "#ff3333", textAlign: "right" }}>
            Clear all notifications
          </span>
          <DeleteIcon
            style={{
              marginTop: "-3px",
              color: "#ff3333",
              marginLeft: "15px",
            }}
          />
        </div>
      </MenuItem>
    </Menu>
  );

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {/* <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="error">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem> */}
      <MenuItem onClick={handleNotificationsMenuOpen}>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={notificationList.length} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  if (state.auth.alert) {
    setSnack2({
      title: state.auth.alert.title,
      message: state.auth.alert.message,
      type: state.auth.alert.type,
    });
    setShowSnack2(true);
    dispatch({ type: "REMOVE_ALERT" });
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (!state.auth.isSocketLoading) {
        state.auth.client.onopen = () => {
          console.log("socket");
        };
        state.auth.client.onmessage = (message) => {
          dispatch(getNotifications());
          var client_message = JSON.parse(message.data);
          console.log(client_message);
          var type = client_message["type"];
          if (type == "text" || type == "attachment") {
            dispatch({ type: "TEXT_MESSAGE", payload: client_message });

            if (window.location.pathname != "/messenger") {
              setSnack({
                title: "New Message!",
                message: client_message["message"],
              });
              setShowSnack(true);
              playAudio();
            }
          }

          if (type == "notification") {
            playAudio();
            setSnack({
              title: client_message["title"],
              message: client_message["message"],
            });
            setShowSnack(true);
            playAudio();
          }
          if (type == "refresh") {
            dispatch({
              type: "REFRESH_DATA",
              payload: client_message["pages"],
            });
          }
        };
      }
      return (
        <div style={{ zIndex: "99" }}>
          <CssBaseline />
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            autoHideDuration={6000}
            open={showSnack}
            onClose={() => setShowSnack(false)}
          >
            <Card style={{ minWidth: "350px", padding: "10px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  <NotificationsIcon
                    style={{
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontSize: "44px",
                    }}
                  />
                  <div style={{ marginLeft: "10px" }}>
                    <b style={{ fontSize: "15px" }}>{snack["title"]}</b>
                    <br></br>
                    <span>{snack["message"]}</span>
                  </div>
                </div>
                <IconButton size="small" onClick={() => setShowSnack(false)}>
                  <CloseIcon style={{ color: "#0065c2" }} />
                </IconButton>
              </div>
            </Card>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            autoHideDuration={6000}
            open={showSnack2}
            onClose={() => setShowSnack2(false)}
          >
            <Card style={{ minWidth: "350px", padding: "10px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  {snack2["type"] == "SUCCESS" ? (
                    <CheckCircleIcon
                      style={{ color: "#2ca25f", fontSize: "44px" }}
                    />
                  ) : snack2["type"] == "MESSAGE" ? (
                    <ErrorIcon
                      style={{
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.primaryColor
                            : themeStyle.primaryColor,
                        fontSize: "44px",
                      }}
                    />
                  ) : (
                    <ErrorIcon style={{ color: "#ff3333", fontSize: "44px" }} />
                  )}
                  <div style={{ marginLeft: "10px" }}>
                    <b style={{ fontSize: "15px" }}>{snack2["title"]}</b>
                    <br></br>
                    <span>{snack2["message"]}</span>
                  </div>
                </div>
                <IconButton size="small" onClick={() => setShowSnack2(false)}>
                  <CloseIcon style={{ color: "#FFA500" }} />
                </IconButton>
              </div>
            </Card>
          </Snackbar>
          <AppBar elevation={0} position="fixed" open={state.auth.sidebarOpen}>
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{
                  marginRight: 5,
                  marginLeft: "-8px",
                  ...(state.auth.sidebarOpen && { display: "none" }),
                }}
              >
                <MenuIcon />
              </IconButton>
              {state.auth.sidebarOpen ? (
                <Fragment></Fragment>
              ) : (
                <Divider
                  orientation="vertical"
                  style={{
                    minHeight: "inherit",
                    color: "red",
                    width: "1px",
                    marginLeft: "-24px",
                  }}
                />
              )}
              <span
                style={{
                  marginLeft: "16px",
                  fontSize: "25px",
                  marginTop: "3px",
                  fontFamily: "Bahnschrift",
                }}
              >
                {name}
              </span>{" "}
              <Box sx={{ flexGrow: 1 }} />
              <div style={{ margin: "10px 17px 10px 10px", width: "50%" }}>
                {props.tabs}
              </div>
              {state.auth.user.full_name}
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                {/* <IconButton
                  size="large"
                  aria-label="show 4 new mails"
                  color="inherit"
                >
                  <Badge badgeContent={4} color="error">
                    <MailIcon />
                  </Badge>
                </IconButton> */}
                <IconButton
                  size="large"
                  aria-label="show 17 new notifications"
                  color="inherit"
                  aria-controls={notificationsMenuId}
                  aria-haspopup="true"
                  onClick={handleNotificationsMenuOpen}
                  style={{ marginLeft: "15px" }}
                >
                  <Badge badgeContent={notificationList.length} color="error">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                <Tooltip
                  arrow
                  title={state.auth.user.full_name}
                  placement="right"
                >
                  <IconButton
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                  >
                    <Avatar
                      alt={state.auth.user.full_name}
                      src={API_URL + "media/" + state.auth.user.user_image}
                    />{" "}
                  </IconButton>
                </Tooltip>
              </Box>
              <Box sx={{ display: { xs: "flex", md: "none" } }}>
                <Tooltip
                  arrow
                  title={state.auth.user.full_name}
                  placement="right"
                >
                  <IconButton
                    size="large"
                    aria-label="show more"
                    aria-controls={mobileMenuId}
                    aria-haspopup="true"
                    onClick={handleMobileMenuOpen}
                    color="inherit"
                  >
                    <Avatar
                      alt={state.auth.user.full_name}
                      src={API_URL + "media/" + state.auth.user.user_image}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            </Toolbar>
          </AppBar>
          {renderMobileMenu}
          {renderMenu}
          {renderNotifications}
          <Drawer
            variant="permanent"
            open={state.auth.sidebarOpen}
            PaperProps={{
              sx: {
                backgroundColor:
                  state.auth.theme == "dark"
                    ? themeStyleDark.backgroundColor
                    : themeStyle.backgroundColor,
              },
            }}
            sx={{
              paper: {
                backgroundColor:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              },
            }}
          >
            <DrawerHeader>
              <img
                style={{
                  backgroundColor:
                    state.auth.theme == "dark"
                      ? themeStyleDark.backgroundColor
                      : themeStyle.backgroundColor,
                  height: "100px",
                  width: "175px",
                  objectFit: "cover",
                  marginRight: "15px",
                }}
                src={require("../img/appbar.png")}
              />
              <IconButton
                style={{
                  color: "#084594",
                  fontSize: "20px",
                  fontWeight: "800",
                  marginLeft: "-1px",
                }}
                onClick={handleDrawerClose}
              >
                {theme.direction === "rtl" ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronLeftIcon />
                )}
              </IconButton>
            </DrawerHeader>

            <List component="nav" aria-label="main mailbox folders" style={{}}>
              <Link to="/dashboard">
                <Tooltip arrow title="Dashboard" placement="right">
                  <ListItem
                    button
                    key="dashboard"
                    style={
                      window.location.pathname === "/" ||
                      window.location.pathname === "/dashboard"
                        ? {
                            backgroundColor:
                              state.auth.theme == "dark"
                                ? themeStyleDark.primaryColor
                                : themeStyle.primaryColor,
                          }
                        : {}
                    }
                  >
                    <ListItemIcon>
                      <DashboardIcon
                        style={
                          window.location.pathname === "/" ||
                          window.location.pathname === "/dashboard"
                            ? {
                                marginLeft: "8px",
                                marginRight: "30px",
                                color: "white",
                              }
                            : { marginLeft: "8px", marginRight: "30px" }
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={
                        window.location.pathname === "/" ||
                        window.location.pathname === "/dashboard"
                          ? {
                              color: "white",
                            }
                          : {}
                      }
                      primary="Dashboard"
                    />
                  </ListItem>
                </Tooltip>
              </Link>
              <Link to="/profiles">
                <Tooltip arrow title="Profiles" placement="right">
                  <ListItem
                    key="profiles"
                    style={
                      window.location.pathname === "/profiles"
                        ? {
                            backgroundColor:
                              state.auth.theme == "dark"
                                ? themeStyleDark.primaryColor
                                : themeStyle.primaryColor,
                          }
                        : {}
                    }
                  >
                    <ListItemIcon>
                      <PeopleAltIcon
                        style={
                          window.location.pathname === "/profiles"
                            ? {
                                marginLeft: "8px",
                                marginRight: "30px",
                                color: "white",
                              }
                            : { marginLeft: "8px", marginRight: "30px" }
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={
                        window.location.pathname === "/profiles"
                          ? {
                              color: "white",
                            }
                          : {}
                      }
                      primary="Profiles"
                    />
                  </ListItem>
                </Tooltip>
              </Link>
              <Link to="/medicines">
                <Tooltip arrow title="Medicines" placement="right">
                  <ListItem
                    button
                    key="medicines"
                    style={
                      window.location.pathname === "/medicines"
                        ? {
                            backgroundColor:
                              state.auth.theme == "dark"
                                ? themeStyleDark.primaryColor
                                : themeStyle.primaryColor,
                          }
                        : {}
                    }
                  >
                    <ListItemIcon>
                      <VaccinesIcon
                        style={
                          window.location.pathname === "/medicines"
                            ? {
                                marginLeft: "8px",
                                marginRight: "30px",
                                color: "white",
                              }
                            : { marginLeft: "8px", marginRight: "30px" }
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={
                        window.location.pathname === "/medicines"
                          ? {
                              color: "white",
                            }
                          : {}
                      }
                      primary="Medicines"
                    />
                  </ListItem>
                </Tooltip>
              </Link>

              <Link to="/media">
                <Tooltip arrow title="Media" placement="right">
                  <ListItem
                    button
                    key="media"
                    style={
                      window.location.pathname === "/media"
                        ? {
                            backgroundColor:
                              state.auth.theme == "dark"
                                ? themeStyleDark.primaryColor
                                : themeStyle.primaryColor,
                          }
                        : {}
                    }
                  >
                    <ListItemIcon>
                      <MovieIcon
                        style={
                          window.location.pathname === "/media"
                            ? {
                                marginLeft: "8px",
                                marginRight: "30px",
                                color: "white",
                              }
                            : { marginLeft: "8px", marginRight: "30px" }
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={
                        window.location.pathname === "/media"
                          ? {
                              color: "white",
                            }
                          : {}
                      }
                      primary="Media"
                    />
                  </ListItem>
                </Tooltip>
              </Link>
              <Link to="/reports">
                <Tooltip arrow title="Reports" placement="right">
                  <ListItem
                    button
                    key="reports"
                    style={
                      window.location.pathname === "/reports"
                        ? {
                            backgroundColor:
                              state.auth.theme == "dark"
                                ? themeStyleDark.primaryColor
                                : themeStyle.primaryColor,
                          }
                        : {}
                    }
                  >
                    <ListItemIcon>
                      <AssessmentIcon
                        style={
                          window.location.pathname === "/reports"
                            ? {
                                marginLeft: "8px",
                                marginRight: "30px",
                                color: "white",
                              }
                            : { marginLeft: "8px", marginRight: "30px" }
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={
                        window.location.pathname === "/reports"
                          ? {
                              color: "white",
                            }
                          : {}
                      }
                      primary="Reports"
                    />
                  </ListItem>
                </Tooltip>
              </Link>
              <Link to="/suggestions">
                <Tooltip arrow title="Suggestions" placement="right">
                  <ListItem
                    button
                    key="reports"
                    style={
                      window.location.pathname === "/suggestions"
                        ? {
                            backgroundColor:
                              state.auth.theme == "dark"
                                ? themeStyleDark.primaryColor
                                : themeStyle.primaryColor,
                          }
                        : {}
                    }
                  >
                    <ListItemIcon>
                      <MessageIcon
                        style={
                          window.location.pathname === "/suggestions"
                            ? {
                                marginLeft: "8px",
                                marginRight: "30px",
                                color: "white",
                              }
                            : { marginLeft: "8px", marginRight: "30px" }
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={
                        window.location.pathname === "/suggestions"
                          ? {
                              color: "white",
                            }
                          : {}
                      }
                      primary="Suggestions"
                    />
                  </ListItem>
                </Tooltip>
              </Link>
            </List>
          </Drawer>
          {renderNotifications}
          {renderMenu}
        </div>
      );
    } else {
      return <Fragment></Fragment>;
    }
  } else {
    return <Fragment></Fragment>;
  }
}

export default Sidebar;
